module.exports = __webpack_public_path__ + "img/Blue-L-1@2x.517e01dc.png";